module.exports = __webpack_public_path__ + "static/media/Mentorship-8.acbddfba.jpg";